<template>
    <div class="multi-select-filter">
        <multi-select v-model="selected" :options="options"/>

        <input type="hidden" v-for="inputValue in inputValues"
               :value="inputValue.value"
               :name="inputValue.name">
    </div>
</template>

<script>
    export default {
        props: {
            options: {
                default: function(){
                    return []
                }
            }
        },

        data: function(){
            return {
                selected: [],
            };
        },

        created: function(){
            this.init();
        },

        computed: {
            inputValues: function(){
                return _.map( this.selected, function( selected ){
                    var result = {
                        name: selected,
                        value: selected,
                    };

                    if( typeof selected === 'object' ){
                        result = selected;
                    }

                    return result;
                } );
            }
        },

        methods: {
            init: function(){
                var self = this;
                var urlParams = new URLSearchParams( window.location.search );

                for( var param of urlParams ){
                    var option = _.find( self.options, function( option ){
                        if( typeof option.value === 'object' ){
                            return option.value.name === param[ 0 ] &&
                                option.value.value === param[ 1 ];
                        }
                        else{
                            return option.value === param[ 0 ] && option.value === param[ 1 ];
                        }
                    } );

                    if( option ){
                        self.selected.push( option.value );
                    }
                }
            }
        }
    }
</script>
